// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__3i8Fq","contained":"OpenButton_contained__2I5dn","disabled":"OpenButton_disabled__10vhJ","error":"OpenButton_error__vEBkj"};